import React from 'react'

function extractReasoningTitle(reasoningSummary: string) {
  const boldMarkerCount = (reasoningSummary.match(/\*\*/g) ?? []).length
  if (boldMarkerCount % 2 === 1) {
    const lastBoldStart = reasoningSummary.lastIndexOf('**')
    if (lastBoldStart >= 0) {
      const partialTitle = reasoningSummary
        .slice(lastBoldStart + 2)
        .split('\n')[0]
        .trim()
      if (partialTitle) return partialTitle
    }
  }

  const boldMatches = Array.from(reasoningSummary.matchAll(/\*\*(.*?)\*\*/g))
    .map((match) => match[1].trim())
    .filter(Boolean)
  if (boldMatches.length > 0) {
    return boldMatches[boldMatches.length - 1]
  }

  const nonEmptyLines = reasoningSummary
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)

  return nonEmptyLines[0]?.replace(/^\*\*|\*\*$/g, '') ?? ''
}

function renderFormattedBlock(text: string) {
  const boldRegex = /\*\*(.*?)\*\*/g
  const parts = text.split(boldRegex)
  const regularClassName = 'text-neutral-500 dark:text-neutral-400'
  const strongClassName = 'font-bold text-neutral-800 dark:text-neutral-200'

  return parts.map((part, index) => {
    if (index % 2 === 1) {
      return (
        <div key={`status-strong-${index}`} className={strongClassName}>
          {part}
        </div>
      )
    }

    if (!part.trim()) return null
    return (
      <div key={`status-regular-${index}`} className={regularClassName}>
        {part.trim()}
      </div>
    )
  })
}

export function formatStatusText(
  text: string,
  reasoningSummary?: string | null,
): React.ReactNode {
  const reasoningTitle = reasoningSummary
    ? extractReasoningTitle(reasoningSummary)
    : null

  return (
    <div className="flex flex-col gap-1">
      {reasoningTitle ? (
        <div className="text-sm not-italic font-semibold text-neutral-900 dark:text-neutral-100">
          {reasoningTitle}
        </div>
      ) : (
        renderFormattedBlock(text)
      )}
    </div>
  )
}
